/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Dialog_VerifyingInputs */



/**
* | output |
* | --- |
* | "Verifying..." |
*
* @param {Integrations_Dialog_VerifyingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_dialog_verifying = /** @type {((inputs?: Integrations_Dialog_VerifyingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Dialog_VerifyingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird geprüft …")
	return /** @type {LocalizedString} */ ("Verifying...")
});